import { Observable } from 'rxjs';
import { CommercialConsentResponseRequestModel, CommercialConsentResultResponseModel } from '../../models/comercial/commercial-consent.model';
import { ComercialRepository } from '../../repositories/comercial.repository';

export class RespondCommercialConsentUseCase {
  constructor(private comercialRepository: ComercialRepository) {}

  execute(params: CommercialConsentResponseRequestModel): Observable<CommercialConsentResultResponseModel> {
    return this.comercialRepository.respondCommercialConsent(params);
  }
}
